export class DashboardCountModel {
    actionTypeSummary: DashboardCountSummartModel[];
    carrierCategoriesSummary: DashboardCountSummartModel[];
    actionStatusSummary: DashboardCountSummartModel[];
}

export class DashboardCountSummartModel {
    summaryType: number;
    listId: number
    name: string;
    recordCount: number;
    colorCode: string;
}

export class DashboardNotesModel {
    notesDate: Date;
    actionNotesId: number
    actionLinkId: number;
    actionId: number;
    updateId: number;
    note: string;
    subject: string;
    colorCode: string;
}

export class TracItActionCalendarSearch {
    userId: number;
    dateFrom: string;
    toDate: string;
    isNeworChanged: boolean = false;
    actionTypeIds: string;
    carrierCatIds: string;
    stateIds: string;
    statusIds: string;
    emailActionId: string;
    emailUpdateId: string;
    emailDeadlineDate: string;
    listOfActionID: string;
    listOfUpdateID: string;
    isFavorite?: boolean = false;
    isMyTracIt?: boolean = false;
    emailBriefingId: string;
    listOfBriefingId: string;
    companySpecificIds: string;
    productId: number;
    Search: string;
    pageNumber: number;
    pageSize: number;
}

export class ActionItemListViewModel {
    deadlineDate: string;
    title: string;
    colorCode: string;
    description: string;
    alertText: string;
    neworChanged: string;
    state: string;
    type: string;
    category: string;
    status: string;
    statusName: string;
    actionId: string;
    updateId: string;
    actionItemTypeId: string;
    createdBy: string;
    createdDate: string;
    modifiedBy: string;
    modifiedDate: string;
    actionLinkId: string;
    assignToId: string;
    actionCreatedBy: string;
    actionCreatedDate: string;
    handleType: string;
    actionModifiedBy: string;
    actionModifiedDate: string;
    notesCount: string;
    notes: string;
    totalRecords: number;
    isInformationOnly: any;
    isAllVisibleForState: any;
    isAllVisibleForCategory: any;
    briefingId: any;
    listOfBriefingId: any;
    reminder: string;
    totalRecordCount: number;
}

export class ActionItemCalendarModel {
    start: string;
    end: string;
    title: string;
}

export class carrierFilterModel {
    orderBy: string;
    keywordFilter: string;
    fromDate: string;
    todate: string;
    updateStatus: string;
    userID: number;
    ID: number;
    Status: number;
    filterFavourite: number;
    newCarrierID: number;
    carrierFilter: string;
}

export class filterModel {
    pageNumber?: string;
    pageSize?: string;
    whereCondition?: string;
    orderBy?: string;
    keywordFilter?: string;
    stateID?: string;
    userID?: string;
    columnIndex?: string;
    productId?: number;
    actionTypes?: string;
    carrierCategories?: string;
    actionSatus?: string;
    listOfProduct?: string;
    emailKey?: string;
    isActionRequired?: boolean;
    oprator?: string;
    fromDate?: string;
    toDate?: string;
    listOfType?: string;
    systemUserCondition?: string;
}

export class ActionItemSearchModel {
    deadlineDate: Date;
    title: string;
    colorCode: string;
    description: string;
    neworChanged: string;
    stateName: string;
    actionTypeName: string;
    carrierNames: string;
    statusName: string;
    actionId: string;
    updateId: string;
    actionItemTypeId: string;
    createdBy: string;
    createdDate: string;
    modifiedBy: string;
    modifiedDate: string;
    actionLinkId: string;
    assignToId: string;
    actionCreatedBy: string;
    actionCreatedDate: string;
    handleType: string;
    actionModifiedBy: string;
    actionModifiedDate: string;
    status: string;
    statusColorCode: string;
    isHideAssignToUser: string;
    isHideRadioOption: string;
    actionCharges: number = 0;
    actionNotes: string = '';
    isInformationOnly: any;
    isAllVisible: any;
    briefingId: string;
    briefingDocPath: string;
    briefingDate: Date;
    displayBriefingDocName: string;
    recurranceId: number;
    CompanyUser: boolean
    internalNotes: string
    reminder: string
    reminderUsers = [];
    visibleTrackIt: number
    alertText: string
}

export class ActionItemUpdateStatusModel {
    userID: number;
    updateId: number;
    actionId: number;
    statusId: number;
    assignToId: number;
    handleType: number;
    note: string;
    productId?: number = 0;
    previousAssingId?: number = 0;
    previousStatus?: number = 0;
    briefingId: number;
    reminder: string;
    reminderUsers = [];
}

export class userModel {
    userId: string;
    userName: string;
    password?: string;
    firstName: string;
    lastName: string;
    email: string;
    companyName?: string;
    city?: string;
    state?: string;
    phone: string;
    userTypeId?: string;
    isActive: string;
    lastLogin?: string;
    createdDate?: string;
    createdBy?: string;
    modifiedDate?: string;
    modifiedBy?: string;
    wirelessStates?: stateMasterModel[];
    voIPStates?: stateMasterModel[];
    iprStates?: stateMasterModel[];
    actionStates?: stateMasterModel[];
    subscriptionStateName?: string;
    subscriptionCount?: string;
    token?: string;
    companyId?: string;
    isICalSubscription?: string;
    encyUserId?: string;
    deadlineDateFromAction?: string;
    deadlineDateFromUpdate?: string;
    adminTypeId?: number;
    adminUserName?: string;
    adminUserId?: number;
    deadlineDateFromBriefing?: string;
}

export class stateMasterModel {
    stateId: string;
    shortName: string;
    name: string;
    isActive: string;
    displayOrder: string;
    createdDate: string;
    createdBy: string;
    modifiedDate: string;
    modifiedBy: string;
    isChecked?: boolean;
    isSelected?: boolean;
    isUpdate: string;
    encyStateId?: string;
    productId: number;
}

export class ActionItemSearchStatusHistoryModel {
    actionStatusId: number;
    actionLinkId: number;
    statusId: number;
    statusName: string;
    note: string;
    createdDate: string;
    createdByName: string;
    statusColorCode: string;
    assignToId: number;
    assignName: string;
    handleType: number;
    alertText: string;
}

export class AddNewActionModel {
    actionId: number;
    actionItemId: number;
    assignToUser: string;
    deadLineDate: string;
    subject: string;
    description: string;
    state: string;
    carrierCategories: string;
    visibleToAllCompanyUsers: boolean;
    createdBy: number;
    companyId: number;
    isNeworChanged: any
    actionType: string;
    isAction: boolean;
    actionCharges: string
    actionNotes: string;
    previousAssingId: string;
    productId: string;
    isSendEmailNotification: any
    isInformationOnly: any
    visibleTrackIt: number
    visibleUserIds = [];
    country: number
    recurrance: string
    reminder: string
    reminderUsers = []
    category: number;
    assignToId: number;
    recurranceId: number;
    selectedItems: number;
    notes: string;
    alertText: string;
}

export class ActionCompanySpecificCategoryModel {
    actionCompanySpecificCategoryId: number;
    name: string;
    companyId: number;
    createdBy: number;
}

export class ActionGetByIdModel {
    actionId: number = 0;
    deadlineDate: Date;
    subject: string;
    description: string;
    actionItemTypeId: number;
    assignToId: number;
    isForAllUsers: boolean;
    listOfCarrierCategory: CarrierCategoryModel[];
    listOfState: ActionStateModel[];
    visibleTrackIt: number
    visibleUserIds = [];
    country: number
    recurrance: string
    reminder: string
    reminderUsers = [];
    category: number;
    recurranceId: number;
    alertText: string;
}

export class ActionStateModel {
    actionStateId: number;
    actionId: number;
    stateName: string;
    stateId: number;
    createdDate: string;
    createdBy: number;
    modifiedDate: string;
    modifiedBy: number;
}

export class CarrierCategoryModel {
    actionCarrId: number;
    actionId: number;
    carrierName: string;
    carrierCatId: number;
    createdDate: string;
    createdBy: number;
    modifiedDate: string;
    modifiedBy: number;
}

export class ActionItemSaveNoteModel {
    userID: number;
    actionNoteId: number;
    updateId: number;
    actionId: number;
    notes: string;
    briefingId: number;
}

export class ActionItemSearchNotesModel {
    actionNoteId: number;
    actionLinkId: number;
    note: string;
    createdDate: Date;
    createdByName: string;
    modifiedDate: Date;
    modifiedByName: string;
}

export class ActionItemTypeModel{
  actionItemTypeId: number ;
  typeName: string;
  colorCode: string;
  isDefaultChecked: boolean;
  isHoliday: boolean;
  isPersonal: boolean;
  createdDate: string;
  createdBy: number;
  modifiedDate: string;
  modifiedBy: number;
  totalRecordCount: number;
  isEdit: boolean = false;
  createdUser: string;
  modifiedUser: string;
  isUserCanDelete?: boolean;
}

export class FavouriteActionItemModel {
  userId: number;
  actionItemTypeId: number;
  typeName: string;
}

export class FavouriteCarrierCategoryModel {
        userId: number;
        carrierCatId: number;
        carrierCatName: string;
}

export class updatesPageModel {
  pageIndex: any;
  pageSize: any;
  whereCondition: string;
  orderBy: string;
  keywordFilter: string;
  fromupdatesDateFilter: string;
  toupdatesDateFilter: string;
  userID: string;
  unreadonly: string;
  updatetype: string;
  productId: string;
}

export class updatesModel {
  updateId?: number;
  updateCategoryId?: number;
  updateCategoryName?: string;
  updateDate?: string;
  stateId?: number;
  stateName?: string;
  stateShortName?: string;
  updateType?: string;
  description?: string;
  matrixFundId?: number;
  matrixFundTitle?: string;
  fundFieldId?: number;
  fundFieldName?: number;
  displayOrder?: number;
  isActive?: boolean;
  isDeleted?: boolean;
  createdDate?: string;
  createdBy?: string;
  createdByName?: string;
  modifiedDate?: string;
  modifiedBy?: string;
  modifiedByName?: string;
  totalRecordCount?: string;
  productId?: string;
  isUpdateRequired?: boolean;
  clientCompanyId?: string;
  companyName?: string;
  actionCharges?: number;
  actionNotes?: string;
  actionTypeId?: number;
  companyUserUpdateModel?: any[];
  totalUserCount?: number;
  companyUserId?: number;
  totalCompanyCount?: number;
  companyEmailStatus?: string;
  isPushActionItem?: string;
}